/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What characters are supported?`)
};

const es_mc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué caracteres se admiten?`)
};

const de_mc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Zeichen werden unterstützt?`)
};

const nl_mc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke tekens worden ondersteund?`)
};

const fr_mc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quels caractères sont pris en charge ?`)
};

const it_mc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quali caratteri sono supportati?`)
};

const pt_br2_mc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quais caracteres são suportados?`)
};

const pt_mc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quais caracteres são suportados?`)
};

const ja_mc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どのような文字がサポートされていますか?`)
};

const zh_mc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持哪些字符？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mc_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mc_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mc_faq2_q", locale)
	if (locale === "en") return en_mc_faq2_q(inputs)
	if (locale === "es") return es_mc_faq2_q(inputs)
	if (locale === "de") return de_mc_faq2_q(inputs)
	if (locale === "nl") return nl_mc_faq2_q(inputs)
	if (locale === "fr") return fr_mc_faq2_q(inputs)
	if (locale === "it") return it_mc_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_mc_faq2_q(inputs)
	if (locale === "pt") return pt_mc_faq2_q(inputs)
	if (locale === "ja") return ja_mc_faq2_q(inputs)
	return zh_mc_faq2_q(inputs)
};